import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/AuthContext";

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="mp-loading">Loading…</div>;
  if (!user) {
    return <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search || ""}` }} />;
  }
  const locked = user.role !== "admin" && user.has_access !== true;
  if (locked && location.pathname !== "/billing") {
    return <Navigate to="/billing?subscribe=1" replace />;
  }
  return children;
}

export function AdminRoute() {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="mp-loading">Loading…</div>;
  if (!user) {
    return <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search || ""}` }} />;
  }
  if (user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return <Outlet />;
}
